export const FONT_WEIGHT_TOKEN = [
    'REGULAR',
    'MEDIUM',
    'SEMIBOLD',
    'BOLD',
    'EXTRABOLD',
];
/* eslint-disable sort-keys */
export const FONT_WEIGHT = {
    REGULAR: 400,
    MEDIUM: 500,
    SEMIBOLD: 600,
    BOLD: 700,
    EXTRABOLD: 800,
};
/* eslint-enable sort-keys */
